import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ProductSplashType, SplashSizes } from '@features/product/product.models';
import { SvgIconComponent } from '@shared/svg-icon/svg-icon.component';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-product-splash',
    templateUrl: './product-splash.component.html',
    styleUrls: ['./product-splash.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, SvgIconComponent]
})
export class ProductSplashComponent {
    @Input()
    public readonly text?: string;

    @Input()
    public readonly amount?: number;

    @Input()
    public readonly type: ProductSplashType = 'statement';

    @Input()
    public readonly size: SplashSizes = 'm';

    @Input()
    public readonly style?: Partial<CSSStyleDeclaration>;

    @HostBinding('class') get dynamicClasses(): string {
        const classes = ['splash', 'splash_' + this.type];
        if (this.type === 'save' || this.type === 'campaign') {
            classes.push('splash_' + this.size);
        }
        return classes.join(' ');
    }

    @HostBinding('style') get dynamicStyles(): Partial<CSSStyleDeclaration> {
        return this.style ? this.style : {};
    }
}
